import type es from '../es/common';

/** `common` in English. Same keys as `es/common.ts`, enforced by the type. */
const common: typeof es = {
  language: {
    label: 'Language',
    es: 'ES',
    en: 'EN',
    esName: 'Español',
    enName: 'English',
  },
  shell: {
    logout: 'Log out',
  },
  surfaces: {
    switcherLabel: 'Switch view',
    candidate: 'Candidate',
    agency: 'Agency',
    operator: 'Operator',
  },
  candidateShell: {
    navLabel: 'Sections',
    dashboard: 'Dashboard',
    messages: 'Messages',
    applications: 'Applications',
    profile: 'Profile',
    unread: (n: number) => `${n} unread`,
    footerLabel: 'More information',
    scoreGuide: 'How your resume score works (in Spanish)',
    terms: 'Terms',
    privacy: 'Privacy',
  },
  viewAs: {
    label: (who: string) => `You're viewing ${who}'s account`,
    someone: 'someone else',
    readOnly: 'Read only: nothing you touch here is saved or sent.',
    exit: 'Exit view',
  },
  referralConsent: {
    notice: (who: string) =>
      `You signed up with ${who}'s code. We share your email and your plan status with the person who invited you, so they can support you.`,
  },
  auth: {
    login: {
      redirecting: 'Redirecting to sign in',
    },
    callback: {
      completing: 'Finishing sign-in',
      errorTitle: 'Sign-in error',
      retry: 'Try again',
      failed: 'Authentication failed',
    },
  },
  sessionExpired: {
    title: 'Your session expired',
    body: "What you were doing wasn't saved. Reload the page to sign back in, then try again.",
    reload: 'Reload',
    hint: 'If it happens again, log out and sign back in.',
  },
  network: {
    offline: "We couldn't reach TBit Jobs. Check your internet connection and try again.",
  },
  errorBoundary: {
    title: 'Something went wrong',
    body: 'If your browser is translating this page, turn translation off for it and try again.',
    reload: 'Reload page',
  },
  whatsappBubble: {
    buttonName: 'Message us',
    brandSubtitle: 'Our assistant answers, any time',
    callToAction: 'Open WhatsApp',
    welcome: 'Hi 👋 Got a question about TBit Jobs? Message us on WhatsApp.',
    prefill: {
      candidates: 'Hi, I have a question about TBit Jobs',
      employers: 'Hi, I want to post jobs on TBit Jobs',
      partners: 'Hi, I want to become a TBit Jobs partner',
    },
  },
};

export default common;
